import { omit, path, pathOr } from 'ramda';
import { createSelector } from 'reselect';
import { ASSIGNMENT_TYPES, CONSTITUENT_TYPES } from './donor.constant';
import { donorInitialState } from './donor.initialState';

export const getDonorById = (state, id) =>
	pathOr({}, ['donor', 'entities'], state)[id] || donorInitialState;
export const getPendingDonorUpdate = state => path(['donor', 'pendingUpdate'], state);
export const getPendingDonors = state => ({
	update: getPendingDonorUpdate(state),
});

export const getDonorErrorUpdate = state => path(['donor', 'updateError'], state);
export const getDonorErrors = state => ({
	update: getDonorErrorUpdate(state),
});
export const getEntities = state => path(['donor', 'entities'], state);
export const getDonors = createSelector(getEntities, entities => Object.values(entities));
export const getTotal = state => path(['donor', 'totalToDisplay'], state);
export const getSkip = state => path(['donor', 'skip'], state);
export const getPendingDonorFetch = state => path(['donor', 'pendingFetch'], state);

export const getDonorFilters = state => path(['donor', 'filters'], state);
export const getAssignmentTypeFilter = state => path(['donor', 'filters', ASSIGNMENT_TYPES], state);
export const getConstituentTypeFilter = state =>
	path(['donor', 'filters', CONSTITUENT_TYPES], state);
export const getOtherDonorFilters = omittedKeys =>
	createSelector(getDonorFilters, filters => omit(omittedKeys, filters));
export const hasDonorFilters = createSelector(
	getDonorFilters,
	filters => Object.keys(filters).length > 0,
);

export const getSortBy = state => path(['donor', 'sortBy'], state);



// WEBPACK FOOTER //
// ./src/redux/donors/donor.selector.js